import { Button, Typography } from "@suraasa/placebo-ui"
import { TooltipRenderProps } from "react-joyride"

const OnboardingStep = ({
  toolTipRenderProps,
  onComplete,
}: {
  toolTipRenderProps: TooltipRenderProps
  onComplete: () => void
}) => {
  const { index, primaryProps, step, isLastStep, size } = toolTipRenderProps

  return (
    <div className="w-full max-w-[calc(100vw_-_32px)] overflow-hidden rounded-xl bg-white sm:w-[345px] sm:max-w-none">
      <div>{step.content}</div>
      <div className="flex w-full items-center justify-between px-2.5 pb-2.5">
        <Typography variant="preTitle" className="text-onSurface-500">
          {index + 1} OF {size}
        </Typography>
        <div className="flex items-center gap-2">
          <Button
            size="sm"
            color="black"
            onClick={e => {
              if (isLastStep) {
                onComplete()
              } else {
                primaryProps.onClick(e)
              }
            }}
          >
            {isLastStep ? "Finish Tour" : "Next"}
          </Button>
        </div>
      </div>
    </div>
  )
}

export default OnboardingStep
